import React from "react";
import { useTranslation } from "react-i18next";
import "./ToggleSwitch.scss";

import { ReactComponent as ListIcon } from "assets/icons/search/list.svg"
import { ReactComponent as MapIcon } from "assets/icons/search/map.svg"

const ToggleSwitch: React.FC<any> = ({ onSelect, selectedValue }) => {
  const { t } = useTranslation();
  const handleChange = (evt: any, type: string) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (evt.target.checked) {
      onSelect({ selected: type })
    }
  }
  return (
    <>
      <div className="toggle-wrapper">
        <input type="radio" name="slider" id="home" onChange={e => handleChange(e, 'list')} defaultChecked={!selectedValue} />
        <input type="radio" name="slider" id="blog" onChange={e => handleChange(e, 'map')} defaultChecked={selectedValue} />
        <nav>
          <label htmlFor="home" className="home">
            <ListIcon />
            {t('searchResults.list')}
          </label>
          <label htmlFor="blog" className="blog">
            <MapIcon /> {t('searchResults.map')}
          </label>
          <div className="slider"></div>
        </nav>
      </div>
    </>
  );
};

export default ToggleSwitch;
